<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [modalHelpIndex]="modalHelpIndex" [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="save()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="okEnabled()" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [resizeHorizontal]="true" [resizeHorizontalMin]="500" [resizeVertical]="true"
    [resizeVerticalMin]="400" (closeButtonActionEmt)="closeModal()">

    <div class="grid-container">
        <res-generic-grid [gridName]="gridName" [automationId]="modalAutomationId" [(isBusy)]="isGridBusy"
            [(isBusyMessage)]="isGridBusyMessage" [pagerVisible]="false" [gridContext]="gridContext"
            [columnDefs]="columnDefs" [rowSelection]="rowSelection" [requestInfo]="requestInfo"
            [responseArrayCallback]="responseArrayCallback">
        </res-generic-grid>
    </div>

    <div class="name-conflict-options">
        <div class="modal-row">
            <div class="modal-row-column-auto">
                <label>On Name Conflict:</label>
            </div>
            <div class="modal-row-column-auto radio-column">
                <res-custom-radio-button [automationId]="'save-to-orgs-modal-name-conflict-create-copy'"
                    [(ngModel)]="nameConflict" content="Create a Copy" name="nameConflict" value="COPY">
                </res-custom-radio-button>
                <res-custom-radio-button [automationId]="'save-to-orgs-modal-name-conflict-overwrite-existing'"
                    [(ngModel)]="nameConflict" content="Overwrite Existing" name="nameConflict" value="OVERWRITE">
                </res-custom-radio-button>
            </div>
        </div>
    </div>

</res-base-modal>